define(
    'views/admin_notes.view',[
        'loader',
        'config',
        'helper',
        'sandbox',

        'text!templates/admin_notes.html'
    ],
    function(Loader, Config, Helper, Sandbox, adminNotesTemplate)
    {
        var $ = Loader.$;
        var _ = Loader._;

        var AdminNotesView = Loader.Backbone.View.extend(
            {

                events: Helper.prepareEventsForDevice(
                    {
                        'click #save_admin_notes': 'saveNote',
                        'change #hotNote': 'changeStatus'
                    },
                    Loader.eventType
                ),

                routes: {
                    "/admin_index.php$": "notes"
                },

                initialize: function()
                {
                    var _this = this;
                    _.bindAll(this, 'render');
                    var user =  this.model.get('users').getMe();

                    this.model.on('startApplication', function(){
                        if ((user.get('groupId') == 1 || user.get('groupId') == 2)
                            && Config.modules.notes.enabled)
                            Helper.filterRoutes(_this.routes, _this);
                    });
                },

                render: function()
                {
                    if (Config.modules.notes.enabled == false) return this;

                    var elem = $(".notesBlock");

                    var compiledTemplate = _.template(
                        adminNotesTemplate,
                        {
                            model: this.model.toJSON(),
                            note: this.model.get('forum').get('note').toJSON(),
                            user: this.model.get('users').getMe().toJSON(),
                            Helper: Helper
                        }
                    );

                    elem.html(compiledTemplate);
                    return this;
                },

                notes: function()
                {
                    var _this = this;

                    var elem = $("#pun-admain1:last");
                    elem.after('<div id="pun-admain1" class="adformal notesBlock"></div>');
                    this.render();

                    this.model.get('forum').get('note').getNote(function(data){
                        _this.render();
                    });
                },

                saveNote: function(e)
                {
                    var button = $(e.target);
                    button.attr('disabled', true);
                    button.val('Сохраняю...');

                    this.model.get('forum').get('note').saveNote({
                        text: $('#admin_note').val(),
                        state: $('#hotNote').is(':checked') ? 'hot' : 'normal',
                        canModify: $('#canModify').val()
                    }, function(){
                        location.reload(true);
                    }, function(){
                        button.attr('disabled', false);
                        button.val('Сохранить');
                        alert('Произошла ошибка при сохранении черновика');
                    });
                },

                changeStatus: function(e)
                {
                    var elem = $('#hotNote'),
                        status = elem.is(':checked') ? 'hot' : 'normal';

                    status == 'hot' && $('#admin_note').addClass('hot');
                    status == 'normal' && $('#admin_note').removeClass('hot');
                }
            });

        return {
            initialize: function(model)
            {
                return new AdminNotesView({
                    el: $("#pun-admain"),
                    model: model
                })
            }
        }
    }
);
